import { lazy } from "react";
import { portfolioRenderLoader } from "@ms/uno-view-portfolio/lib/local/controls/adapter/portfolioViewLazyLoader";
export const LazyPortfolioView = /*#__PURE__*/ lazy(()=>portfolioRenderLoader().then((mod)=>{
        return {
            default: ()=>mod.render({
                    modalLayerHostId: "modalLayerHostId"
                })
        };
    }));
